import {
  CreateWorkerEducationEntryRequest,
  CreateWorkerExperienceEntryRequest,
  WorkerEducationEntryResponse,
  WorkerExperienceEntryResponse,
} from '@scale/genai-data-service-client';
import apiFetch from '@scale/frontend-lib/api-fetch';

type CreateWorkerEducationEntryBody = Omit<
  CreateWorkerEducationEntryRequest,
  'id' | 'worker' | 'verificationStatus'
>;
type CreateWorkerExperienceEntryBody = Omit<
  CreateWorkerExperienceEntryRequest,
  'id' | 'worker' | 'verificationStatus'
>;
type UpdateWorkerEducationEntryBody = Partial<CreateWorkerEducationEntryBody>;
type UpdateWorkerExperienceEntryBody = Partial<CreateWorkerExperienceEntryBody>;

export async function getEducationEntries(): Promise<WorkerEducationEntryResponse[]> {
  return apiFetch(null, 'internal/worker-properties/education', {
    method: 'GET',
  });
}

export async function createEducationEntry(
  body: CreateWorkerEducationEntryBody,
): Promise<{ id: string }> {
  return apiFetch(null, 'internal/worker-properties/education', {
    method: 'POST',
    body: JSON.stringify(body),
    headers: { 'Content-Type': 'application/json' },
  });
}

export async function updateEducationEntry(
  id: string,
  body: UpdateWorkerEducationEntryBody,
): Promise<{ success: boolean }> {
  return apiFetch(null, `internal/worker-properties/education/${id}`, {
    method: 'PUT',
    body: JSON.stringify(body),
    headers: { 'Content-Type': 'application/json' },
  });
}

export async function deleteEducationEntry(id: string): Promise<{ success: boolean }> {
  return apiFetch(null, `internal/worker-properties/education/${id}`, {
    method: 'DELETE',
  });
}

export async function getExperienceEntries(): Promise<WorkerExperienceEntryResponse[]> {
  return apiFetch(null, 'internal/worker-properties/experience', {
    method: 'GET',
  });
}

export async function createExperienceEntry(
  body: CreateWorkerExperienceEntryBody,
): Promise<{ id: string }> {
  return apiFetch(null, 'internal/worker-properties/experience', {
    method: 'POST',
    body: JSON.stringify(body),
    headers: { 'Content-Type': 'application/json' },
  });
}

export async function updateExperienceEntry(
  id: string,
  body: UpdateWorkerExperienceEntryBody,
): Promise<{ success: boolean }> {
  return apiFetch(null, `internal/worker-properties/experience/${id}`, {
    method: 'PUT',
    body: JSON.stringify(body),
    headers: { 'Content-Type': 'application/json' },
  });
}

export async function deleteExperienceEntry(id: string): Promise<{ success: boolean }> {
  return apiFetch(null, `internal/worker-properties/experience/${id}`, {
    method: 'DELETE',
  });
}
